var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cancelled_Grid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancelled_Grid",
    clipPath: "url(#clip-Cancelled_Grid)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22107",
    "data-name": "Path 22107",
    d: "M6.649,0a6.62,6.62,0,0,1,6.643,6.668A6.646,6.646,0,1,1,0,6.652,6.625,6.625,0,0,1,6.649,0m5.461,6.66A5.461,5.461,0,1,0,1.189,6.652a5.461,5.461,0,1,0,10.921.009",
    transform: "translate(0.314 0.307)",
    fill: "#e33b00",
    stroke: "#e33b00",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22108",
    "data-name": "Path 22108",
    d: "M117.117,116.539l.826-.835c.163-.165.325-.332.493-.491a.585.585,0,0,1,.823.831c-.38.39-.767.773-1.153,1.157a1.1,1.1,0,0,1-.151.105c.064.07.1.109.133.144l1.144,1.147a.565.565,0,0,1,.172.606.589.589,0,0,1-.479.414.567.567,0,0,1-.523-.191q-.564-.561-1.124-1.126a1.534,1.534,0,0,1-.112-.145c-.062.058-.1.09-.136.126-.385.385-.767.773-1.155,1.155a.551.551,0,0,1-.581.166.591.591,0,0,1-.429-.467.569.569,0,0,1,.188-.538q.562-.563,1.125-1.126c.04-.04.088-.072.144-.117-.052-.057-.084-.1-.119-.131q-.577-.579-1.154-1.157a.556.556,0,0,1-.168-.594.591.591,0,0,1,.473-.422.562.562,0,0,1,.525.185q.573.572,1.143,1.147a.905.905,0,0,1,.1.155",
    transform: "translate(-110.18 -110.368)",
    fill: "#e33b00",
    stroke: "#e33b00",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.542f61aa35e927ee0487a95d87bddd58.svg";
export { ForwardRef as ReactComponent };